<template>
  <v-autocomplete
    v-bind="$attrs"
    item-text="number"
    :item-value="fullData ? null : 'id'"
    hide-no-data
    :dense="dense"
    :hide-details="hideDetails"
    :items="foundCars"
    :loading="loading"
    :search-input.sync="input"
    :menu-props="{ maxHeight: 200 }"
    :value="number"
    :autofocus="autofocus"
    @change="onChange"
  />
</template>

<script>
export default {
  props: {
    number: {
      type: String,
      default: '',
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: true,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    fullData: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loading: false,
    input: '',
    value: '',
    foundCars: [],
  }),
  watch: {
    number: {
      immediate: true,
      handler(value) {
        setTimeout(() => {
          this.input = value;
        });
      },
    },
    input(value) {
      if (!value) return;
      if (this.number === value) return;

      this.fetchCars(value);
    },
  },
  methods: {
    async fetchCars(value) {
      this.loading = true;
      this.foundCars = await this.$store.dispatch(
        'workers-board/searchExistingCars',
        value,
      );
      this.loading = false;
    },
    onChange(event) {
      if (this.fullData) {
        this.$emit('change', event);
        return;
      }

      this.$emit('change', { car_id: event });
    },
  },
};
</script>

<style>
.v-select__slot input {
  font-size: 12px;
  margin-top: 2px !important;
  margin-bottom: 2px !important;
}
</style>
